import React from 'react';

function ProductCard({ product, category, onClick, isAuthenticated, hasAnySctChoice, currency, formatPrice, currencyLoading }) {

  const price = product.user_price || {
    exw_bulk_price: product.exw_bulk_price,
    exw_ibc_price: product.exw_ibc_price,
    cost_in_oil: product.cost_in_oil
  };

  // Рассчитываем стоимость в масле
  const costInOil = price.exw_bulk_price * product.treat_rate / 100;

  // Функция для форматирования цены с валютой
  const formatPriceWithCurrency = (priceUSD) => {
    if (!isAuthenticated) return '$$$';
    if (currencyLoading) return '...';
    return formatPrice(priceUSD);
  };

  return (
    <div className="C" onClick={onClick} style={{ display: 'block', position: 'relative' }}>
      <div style={{ height: '3px', background: product.color }}></div>

      {/* ========== ПЛАШКА SCT CHOICE ========== */}
      {product.sct_choice && (
        <div style={{
          position: 'absolute',
          top: '8px',
          left: '8px',
          background: '#FFC72C',
          color: '#000000',
          fontSize: '8px',
          fontWeight: '700',
          padding: '2px 8px',
          borderRadius: '10px',
          zIndex: 10,
          boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
          textTransform: 'uppercase',
          letterSpacing: '0.3px',
          display: 'flex',
          alignItems: 'center',
          gap: '2px',
          lineHeight: '1.2'
        }}>
          <span style={{ fontSize: '7px' }}>★</span>
          BEST CHOICE
        </div>
      )}
      {/* ========== КОНЕЦ ПЛАШКИ ========== */}
       {/* Добавим отступ сверху у контента, если плашка есть */}
      <div style={{ padding: hasAnySctChoice ? '12px 14px' : '6px 14px' }}></div>

      <div style={{ padding: '0px 14px 12px 14px' }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'flex-start', 
          marginBottom: '6px' 
        }}>
          <div>
            <div style={{ 
              fontSize: '8px', 
              fontWeight: '700', 
              color: product.color, 
              letterSpacing: '1px', 
              textTransform: 'uppercase' 
            }}>
              {product.package_number}
            </div>
            <div style={{ fontSize: '14px', fontWeight: '800', color: '#111827' }}>
              {product.code}
            </div>
            <div style={{ fontSize: '10px', color: '#6B7280' }}>
              {product.name}
            </div>
          </div>
          <div style={{ 
            padding: '2px 6px', 
            borderRadius: '4px', 
            background: `${product.color}10`, 
            border: `1px solid ${product.color}20`, 
            fontSize: '9px', 
            fontWeight: '700', 
            color: product.color, 
            whiteSpace: 'nowrap' 
          }}>
            {product.api_spec}
          </div>
        </div>
        <p style={{ 
          fontSize: '9px', 
          color: '#4B5563', 
          lineHeight: '1.4', 
          margin: '0 0 8px', 
          fontStyle: 'italic' 
        }}>
          {product.description}
        </p>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr 1fr 1fr 1fr', 
          gap: '4px' 
        }}>
          <div style={{ padding: '4px 5px', background: '#F9FAFB', borderRadius: '4px' }}>
            <div style={{ fontSize: '6px', color: '#9CA3AF', fontWeight: '600' }}>TBN</div>
            <div style={{ fontSize: '12px', fontWeight: '800', color: '#111827', fontFamily: 'monospace' }}>
              {product.tbn}
            </div>
          </div>
          <div style={{ padding: '4px 5px', background: '#F9FAFB', borderRadius: '4px' }}>
            <div style={{ fontSize: '6px', color: '#9CA3AF', fontWeight: '600' }}>TREAT</div>
            <div style={{ fontSize: '12px', fontWeight: '800', color: '#111827', fontFamily: 'monospace' }}>
              {product.treat_rate}%
            </div>
          </div>
          <div style={{ padding: '4px 5px', background: '#F9FAFB', borderRadius: '4px' }}>
            <div style={{ fontSize: '6px', color: '#9CA3AF', fontWeight: '600' }}>ASH</div>
            <div style={{ fontSize: '12px', fontWeight: '800', color: '#111827', fontFamily: 'monospace' }}>
              {product.ash || '—'}
            </div>
          </div>
          {product.tbn_in_oil && product.tbn_in_oil > 0 && (
            <div style={{ 
              padding: '4px 5px', 
              background: '#FEF3C7', 
              borderRadius: '4px', 
              border: '1px solid #FDE68A' 
            }}>
              <div style={{ fontSize: '6px', color: '#92400E', fontWeight: '600' }}>TBN IN OIL</div>
              <div style={{ fontSize: '12px', fontWeight: '800', color: '#92400E', fontFamily: 'monospace' }}>
                {product.tbn_in_oil}
              </div>
            </div>
          )}
        </div>

        {/* Цены */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr 1fr', 
          gap: '4px', 
          marginTop: '8px' 
        }}>
          <div style={{ 
            padding: '4px 5px', 
            background: '#EFF6FF', 
            borderRadius: '4px', 
            border: '1px solid #BFDBFE' 
          }}>
            <div style={{ fontSize: '6px', color: '#1D4ED8', fontWeight: '600' }}>EXW BULK</div>
            <div style={{ fontSize: '12px', fontWeight: '800', color: '#1D4ED8', fontFamily: 'monospace' }}>
              {formatPriceWithCurrency(price.exw_bulk_price)}
            </div>
          </div>
          <div style={{ 
            padding: '4px 5px', 
            background: '#EFF6FF', 
            borderRadius: '4px', 
            border: '1px solid #BFDBFE' 
          }}>
            <div style={{ fontSize: '6px', color: '#1D4ED8', fontWeight: '600' }}>EXW IBC</div>
            <div style={{ fontSize: '12px', fontWeight: '800', color: '#1D4ED8', fontFamily: 'monospace' }}>
              {formatPriceWithCurrency(price.exw_ibc_price)}
            </div>
          </div>
          <div style={{ 
            marginTop: '4px', 
            padding: '4px 5px', 
            background: '#F0FDF4', 
            borderRadius: '4px', 
            border: '1px solid #BBF7D0',
            gridColumn: '1 / -1'
          }}>
            <div style={{ fontSize: '6px', color: '#166534', fontWeight: '600' }}>COST IN FINISHED OIL ({currency})</div>
            <div style={{ fontSize: '12px', fontWeight: '800', color: '#166534', fontFamily: 'monospace' }}>
              {isAuthenticated ? formatPriceWithCurrency(costInOil) + '/MT' : '$$$/MT'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
